module.exports = __webpack_public_path__ + "img/topBanner.ba564b41.png";